@if (buildDetails) {
  <div class="build-details secondary">
    <section
      class="build-section d-flex align-items-center justify-content-between"
    >
      <label class="build-details-title">Build Details</label>
      @if (buildDetails.commitId !== oaiboxTelemetry?.commitId) {
        <div class="new-build-available-status warning">
          <i class="fa-solid fa-triangle-exclamation"></i> New Build Available
        </div>
      } @else {
        <div class="new-build-available-status success">
          <i class="fa-solid fa-check-double"></i> OAIBOX Updated
        </div>
      }
    </section>
    <!-- commit mismatch -->
    <div class="h-divider"></div>
    <div>
      @if (buildDetails.commitId) {
        <div [oaiboxCopy]="buildDetails.commitId">
          {{ buildDetails.commitId }}
        </div>
      } @else {
        <div>--</div>
      }
      <div class="under-label">Available Build Commit</div>
    </div>
    <div>
      @if (oaiboxTelemetry?.commitId) {
        <div [oaiboxCopy]="oaiboxTelemetry?.commitId">
          {{ oaiboxTelemetry?.commitId }}
        </div>
      } @else {
        <div>Unknown</div>
      }
      <div class="under-label">Current Build Commit</div>
    </div>
    <!-- checksum -->
    <div class="h-divider"></div>
    <div>
      @if (oaiboxTelemetry?.checksum) {
        <div [oaiboxCopy]="oaiboxTelemetry?.checksum">
          {{ oaiboxTelemetry?.checksum }}
        </div>
      } @else {
        <div>--</div>
      }
      <div class="under-label">Current Build Checksum</div>
    </div>
    <!-- Secret -->
    <div class="h-divider"></div>
    <div>
      <div [oaiboxCopy]="buildDetails.secret">
        <button
          class="eye-button"
          (mousedown)="SECRET.classList.add('show')"
          (mouseleave)="SECRET.classList.remove('show')"
          (mouseup)="SECRET.classList.remove('show')"
        >
          @if (!SECRET.classList.contains("show")) {
            <i class="fa-regular fa-eye"></i>
          } @else {
            <i class="fa-regular fa-eye-slash"></i>
          }
        </button>
        <span #SECRET class="build-secret">{{ buildDetails.secret }}</span>
      </div>
      <label class="under-label">Secret</label>
    </div>
    <!-- Last update -->
    <div class="h-divider"></div>
    <section>
      <div class="build-last-update">
        {{ buildDetails.updatedAt | date: "dd/MM/yyyy HH:mm:ss" }}
      </div>
      <label class="under-label">Last Update</label>
    </section>
  </div>
}
